import { useState } from "react";

export default function SearchForm({ onSearch }) {
  const [city, setCity] = useState("");

  function handleSubmit(event) {
    event.preventDefault();
    onSearch(city);
  }

  return (
    <form className="search-form" onSubmit={handleSubmit}>
      <input
        type="search"
        placeholder="Enter a city..."
        required
        className="search-form-input"
        value={city}
        onChange={(e) => setCity(e.target.value)}
      />
      <input type="submit" value="Search" className="search-form-btn" />
    </form>
  );
}
